<template>
    <div class="title1">
        <P>感知设备规模</P>
        <div class="title-info">Perceived device size</div>
    </div>
    <div class="box">
        <ul class="box-list">
            <li v-for="(item,i) in list1" :key="i">
                <P>{{item.name}}</P>
                <div class="info-box">{{item.num}}</div>
            </li>
        </ul>
        <ul class="box-list1">
            <li>
                <span>门禁探测器</span>
                <i></i>
                <p>10</p>
            </li>
            <li>
                <span>门禁探测器</span>
                <i></i>
                <p>10</p>
            </li>
            <li>
                <span>红外被动探测器</span>
                <i></i>
                <p>10</p>
            </li>
            <li>
                <span>门禁探测器</span>
                <i></i>
                <p>10</p>
            </li>
            <li>
                <span>门禁探测器</span>
                <i></i>
                <p>10</p>
            </li>
        </ul>
    </div>
</template>

<script>
    import {reactive} from 'vue'
    export default {
        name: "perceived",
        setup(){
            var list1 = reactive([
                {
                    name:'总数',
                    num:457856,
                },{
                    name:'在线',
                    num:13131
                },{
                    name:'离线',
                    num:451
                },{
                    name:'告警',
                    num:65231
                }
            ]);
            return{
                list1
            }
        }
    }
</script>

<style scoped lang="less">
    @import "./../../assets/canshu";
    .box{
        width: 363px;
        height: 277vh*@vh;
        background: url("./../../assets/perceived-bg.png") no-repeat;
        background-size: 100% 100%;
        margin-top: 26vh*@vh;
        font-family: cn;
        color: #fff;
        box-sizing: border-box;
        padding-top: 8vh*@vh;
    }
    .box-list{
        display: flex;
        justify-content: space-around;
        li{
            p{
                text-align: center;
                font-size: 12px;
                margin-bottom: 4vh*@vh;
            }
            .info-box{
                width: 80px;
                height: 21vh*@vh;
                background: url("./../../assets/perceived-list1.png") no-repeat;
                background-size: 100% 100%;
                font-size: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            &:nth-of-type(3){
                .info-box{
                    background: url("./../../assets/perceived-list3.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
            &:nth-of-type(4){
                .info-box{
                    background: url("./../../assets/perceived-list4.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }
    .box-list1{
        width: 100%;
        margin-top: 32vh*@vh;
        li{
            display: flex;
            width: 360px;
            height: 25vh*@vh;
            box-sizing: border-box;
            justify-content: space-between;
            align-items: center;
            padding: 0 27px;
            margin-bottom: 16vh*@vh;
            cursor: pointer;
            &:hover{
                background: url("./../../assets/perceived-list-active.png") no-repeat;
                background-size: 100% 100%;
            }
            span{
                font-size: 12px;
            }
            p{
                font-size: 16px;
            }
            i{
                display: block;
                width: 187px;
                height: 2px;/*no*/
                background: url("./../../assets/perceived-list-sqlit.png") no-repeat;
            }
            &:nth-of-type(3){
                i{
                    display: block;
                    width: 163px;
                    height: 2px;/*no*/
                    background: url("./../../assets/perceived-list-sqlit1.png") no-repeat;
                }
            }
        }
    }
</style>